module.exports = __webpack_public_path__ + "img/Icon-Onboarding.56ba9847.svg";